module.exports = __webpack_public_path__ + "static/img/13.6406d47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/13.png
// module id = IGOv
// module chunks = 0